import axios from '../../axios'
import UserStore from '@stores/UserStore'
import Store from 'store'
import { addZhiniaoPrefix } from '@utils/SSOHelper'

export default {
  /**
   * 消息未读
   */
  queryMessageUnRead: () => {
    return axios.get(
      addZhiniaoPrefix('/learn/app/clientapi/live/school/comment/msg/unreadCount.do')
    )
  },

  getAllNewContent: (lv: number, messageLv: number | string) => {
    return axios.get('/learn/app/clientapi/message/hasNewContent.do', {
      params: {
        lv,
        messageLv,
        sid: { sid: UserStore.getSid() || Store.get('sessionInfo')?.sid },
      },
    })
  },

  getPracticalContent: () => {
    return axios.get(
      '/learn/app/clientapi/trainingclass/practical/mentor/queryNewMentorContent.do',
      {}
    )
  },

  singleSecurities: (): Promise<any> => {
    return axios.get('learn/app/clientapi/secretfreelogin/getSecretFreeLoginParam.do')
  },

  getZhiniaoCourse: (): Promise<any> => {
    return axios.get(
      'learn/app/clientapi/user/uclass/getToken.do',
      {
        params: {
          sid: UserStore.getSid(),
        },
      }
    )
  },

  /* 判断当前主播是否有直播中的直播 */
  checkAnchorLiving: (): Promise<any> => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/room/checkAnchorLiving.do'))
  },

  /* 判断当前用户是否主播 */
  checkIsAnchor: (): Promise<any> => {
    return axios.get(addZhiniaoPrefix('/learn/app/clientapi/live/room/isAnchor.do'))
  },

}
